import chroma from 'chroma-js';

import { CLASSIC_GRAY_TEXT_COLOR } from 'types/theme-packs';
import getRelativeContrastColor from './generate-relative-contrasting-color';
import getMutedContrastColor from './get-muted-contrast-color';

type TContrastOptions = Parameters<typeof getRelativeContrastColor>[2];

// the 3:1 color moves the same way as the 4.5:1 color so borders stay on the same side of the surface as placeholders
const getTextAndNonTextColors = (surfaceColor: string, getColor: (options: TContrastOptions) => string) => {
	const textColor = getColor({ targetAA: true, fallbackToBestPossible: true });

	let direction: 'darker' | 'lighter' | undefined;
	if (chroma.valid(textColor) && chroma.valid(surfaceColor)) {
		direction = chroma(textColor).luminance() < chroma(surfaceColor).luminance() ? 'darker' : 'lighter';
	}

	const nonTextColor = getColor({ targetNonText: true, fallbackToBestPossible: true, direction });
	return [textColor, nonTextColor];
};

const getFieldContrastVariables = (bodyTextColor: string, backgroundColor: string, containerColor: string) => {
	const [mutedBodyTextOnBackground, nonTextMutedBodyTextOnBackground] = getTextAndNonTextColors(backgroundColor, (options) => {
		return getMutedContrastColor(bodyTextColor, backgroundColor, options);
	});
	const [mutedBodyTextOnContainer, nonTextMutedBodyTextOnContainer] = getTextAndNonTextColors(containerColor, (options) => {
		return getMutedContrastColor(bodyTextColor, containerColor, options);
	});
	const [classicGrayOnBackground, nonTextClassicGrayOnBackground] = getTextAndNonTextColors(backgroundColor, (options) => {
		return getRelativeContrastColor(CLASSIC_GRAY_TEXT_COLOR, backgroundColor, options);
	});
	const [classicGrayOnContainer, nonTextClassicGrayOnContainer] = getTextAndNonTextColors(containerColor, (options) => {
		return getRelativeContrastColor(CLASSIC_GRAY_TEXT_COLOR, containerColor, options);
	});

	return `
			--mutedBodyTextOnBackgroundColor: ${mutedBodyTextOnBackground};
			--mutedBodyTextOnContainerColor: ${mutedBodyTextOnContainer};
			--nonTextMutedBodyTextOnBackgroundColor: ${nonTextMutedBodyTextOnBackground};
			--nonTextMutedBodyTextOnContainerColor: ${nonTextMutedBodyTextOnContainer};
			--classicGrayOnBackgroundColor: ${classicGrayOnBackground};
			--classicGrayOnContainerColor: ${classicGrayOnContainer};
			--nonTextClassicGrayOnBackgroundColor: ${nonTextClassicGrayOnBackground};
			--nonTextClassicGrayOnContainerColor: ${nonTextClassicGrayOnContainer};
	`;
};

export default getFieldContrastVariables;
